import { render, staticRenderFns } from "./serviceArea.vue?vue&type=template&id=c920e3c0&scoped=true"
import script from "./serviceArea.vue?vue&type=script&lang=js"
export * from "./serviceArea.vue?vue&type=script&lang=js"
import style0 from "./serviceArea.vue?vue&type=style&index=0&id=c920e3c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c920e3c0",
  null
  
)

export default component.exports